export const popoverWrapperStyles = {
  '& .MuiPopover-paper': {
    borderRadius: ({ shape }) => shape.radius.l,
    boxShadow: ({ palette }) => palette.shadow.m,
  },
};

export const popoverContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  padding: '8px',
  minWidth: '180px',
};

export const buttonStyles = {
  justifyContent: 'start',
  padding: '8px',
  textTransform: 'none',
  color: ({ palette }) => `${palette.text.dark} !important`,
  backgroundColor: 'transparent !important',
  height: 'fit-content',

  '& .MuiButton-startIcon': {
    marginLeft: 0,
    marginRight: '8px',
  },

  '&:hover': {
    backgroundColor: ({ palette }) => `${palette.background.disabled} !important`,
  },

  '&.Mui-disabled': {
    color: ({ palette }) => `${palette.text.disabled} !important`,
    backgroundColor: 'transparent !important',
    opacity: 1,
  },
};

export const itemTextWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left',
};

export const descriptionStyles = {
  maxWidth: '220px',
  whiteSpace: 'normal',
};
